// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hidetabss {
  /* margin-left:10px; */
  /* margin-top: 25px; */
}`, "",{"version":3,"sources":["webpack://./routes/userlistsettings/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,sBAAA;AACF","sourcesContent":[".hidetabss {\n  /* margin-left:10px; */\n  /* margin-top: 25px; */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
